import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateColumn,
    NonZeroNumberColumn,
    ExternalReceptacleLinkColumn,
  } = columns(data);
  return [
    {
      Header: '',
      columns: [
        new ExternalReceptacleLinkColumn(new TextColumn('Receptacle ID', 'receptacleId')
          .withWidth(300)),
        new DateColumn('Completion date', 'completionDate').withWidth(120),
        new TextColumn('Completion time', 'completionTime').withWidth(120),
        new TextColumn('Category', 'category'),
      ],
    },
    {
      Header: 'RESCON',
      columns: [
        new DateColumn('Scan date', 'rescon.scanDate'),
        new TextColumn('Scan time', 'rescon.scanTime'),
      ],
    },
    {
      Header: 'Receptacle type',
      columns: [
        new TextColumn('PRECON', 'receptacleType.precon'),
        new TextColumn('RESCON', 'receptacleType.rescon'),
      ],
    },
    {
      Header: 'Mail class',
      columns: [
        new TextColumn('PRECON', 'mailClass.precon'),
        new TextColumn('RESCON', 'mailClass.rescon'),
      ],
    },
    {
      Header: 'Documents included',
      columns: [
        new TextColumn('PRECON', 'documentsIncluded.precon'),
        new TextColumn('RESCON', 'documentsIncluded.rescon'),
      ],
    },
    {
      Header: 'Dangerous goods',
      columns: [
        new TextColumn('PRECON', 'dangerousGoods.precon'),
        new TextColumn('RESCON', 'dangerousGoods.rescon'),
      ],
    },
    {
      Header: 'Format of contents',
      columns: [
        new TextColumn('PRECON', 'formatOfContents.precon'),
        new TextColumn('RESCON', 'formatOfContents.rescon'),
      ],
    },
    {
      Header: 'Handling class',
      columns: [
        new TextColumn('PRECON', 'handlingClass.precon'),
        new TextColumn('RESCON', 'handlingClass.rescon'),
      ],
    },
    {
      Header: 'Tracked',
      columns: [
        new TextColumn('PRECON', 'tracked.precon'),
        new TextColumn('RESCON', 'tracked.rescon'),
      ],
    },
    {
      Header: 'Exempt',
      columns: [
        new TextColumn('PRECON', 'exempt.precon'),
        new TextColumn('RESCON', 'exempt.rescon'),
      ],
    },
    {
      Header: 'Weight',
      columns: [
        new NonZeroNumberColumn('PRECON', 'weight.precon'),
        new NonZeroNumberColumn('RESCON', 'weight.rescon'),
      ],
    },
  ];
};
